/* global angular, $ */
angular.module('ua5App')
    .directive('randomBox', ['$timeout', 'BREAKPOINTS', function($timeout, BREAKPOINTS) {
        return {
            restrict: 'E',
            templateUrl: 'components/random_box/random_box.html',
            replace: true,
            scope: {
                posts: '=',
                clickHandler: '='
            },
            link: function($scope, $element, $attrs) {
                var $$element = $($element);
                var width = 100;
                // Increase default width if there are not many images.
                if ($scope.posts.length <= 4) {
                    width = 170;
                }
                function arrange() {
                    if ($(window).width() > BREAKPOINTS.MOBILE) {
                        $$element.arrange({
                            arrange: '.random-box__image',
                            slack: 10
                        });
                    }
                }
                $scope.$on('app:resized', function() {
                    arrange();
                });
                $timeout(function() {
                    var $$images = $$element.find('.random-box__image');
                    // Set width of images
                    $$images.width(width);
                    $$element.imagesLoaded(function() {
                        arrange();
                    });
                });
                $scope.$on('$destroy', function() {
                    $$element.off();
                });
            }
        };
    }])
;
